import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListSocialChannelsV1Response } from './list-social-channels-v1-response';
import { listSocialChannelsV1ResponseSchema } from './list-social-channels-v1-response';

export async function listSocialChannelsV1Api(): Promise<
  IValidatedResponse<IListSocialChannelsV1Response>
> {
  return getRequest<IListSocialChannelsV1Response>({
    path: '/sys/social/v1/channels',
    schema: listSocialChannelsV1ResponseSchema,
  });
}
